import DictionaryItem from './dictionary-item';

class DictionaryAll {
    regions: DictionaryItem[] = [];
    specialities: DictionaryItem[] = [];
    doctors: DictionaryItem[] = [];
    clinics: DictionaryItem[] = [];
    appointmnetTypes: DictionaryItem[] = [];
}

export default DictionaryAll;